import React, { createContext } from 'react';
import Layout from '@/presentation/layout/Layout';
import SelectivityTemplateMaintenanceGrid from './SelectivityTemplateMaintenanceGrid';
import Text from '@/presentation/text/Text.styled';
import useGridSelection from '@/hooks/useGridSelection';
import { SActions, STitleCount } from '../shared/styles/ListHeader.styled';
import { useAppDispatch, useAppSelector } from '@/hooks/customHooks';
import { process as kendoProcess } from '@progress/kendo-data-query';
import Link from '@/presentation/link';
import { setTemplateMaintenanceGridDataState } from '@/features/selectivitySlice';
import { SMessageListDiv, SMessages } from '../message-center/styles/MessageCenter.styled';
import { STemplateMaintenanceContainer } from './styles/SelectivityTemplateMaintenance.styled';

const SelectivityTemplateMaintenance: React.FC = () => {
  const gridSelection = useGridSelection();
  const selectivityState = useAppSelector((state) => state.selectivity.selectivityTemplates);
  const selectivityTemplatesGridData = useAppSelector((state) => state.selectivity.selectivityTemplates.templateList);
  const selectivityTemplatesGridDataState = useAppSelector(
    (state) => state.selectivity.selectivityTemplates.gridDataState,
  );
  const dispatch = useAppDispatch();

  const resultsWithoutPagination = kendoProcess(selectivityTemplatesGridData, {
    ...selectivityTemplatesGridDataState,
    skip: undefined,
    take: undefined,
  }).data;

  const clearTemplatesGridFilterHandler = () => {
    dispatch(setTemplateMaintenanceGridDataState({ ...selectivityState.gridDataState, filter: undefined }));
  };

  const renderClearFilterCTA = () => {
    if (selectivityState.gridDataState.filter && selectivityState.gridDataState.filter?.filters.length) {
      return (
        <>
          <Link
            id="btnClearTemplateFilters"
            icon="faEraser"
            noUnderline
            label="Clear Filters"
            onClick={clearTemplatesGridFilterHandler}
          />
        </>
      );
    }
  };

  return (
    <Layout>
      <SelectedGridContext.Provider value={{ ...gridSelection }}>
        <STemplateMaintenanceContainer>
          <div className="templates-container">
            <div className="templates-header">
              <Text size="xl" className="overall-header" weight="bold">
                Selectivity Templates
              </Text>
              <STitleCount id="lblMsgCount">{resultsWithoutPagination?.length}</STitleCount>
            </div>
            <SActions>{renderClearFilterCTA()}</SActions>
          </div>
        </STemplateMaintenanceContainer>
        <SMessages expanded={false}>
          <SMessageListDiv>
            <SelectivityTemplateMaintenanceGrid />
          </SMessageListDiv>
        </SMessages>
      </SelectedGridContext.Provider>
    </Layout>
  );
};

export default SelectivityTemplateMaintenance;
export const SelectedGridContext = createContext<any>(null);
